
import MiezzButton from "@/models/MiezzButton";
import moment from "moment";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
export default class MiezzButtonSource extends Vue {
  @Prop() model = new MiezzButton();
  @Prop() isDropdown?: boolean;

  created(): void {
    const countdowns: {
      url: string;
      code: string;
      groupby?: string;
      countdown: Date;
    }[] = JSON.parse(localStorage.getItem("countdowns") ?? "[]");
    let countdown = countdowns.firstOrDefault(
      (it) =>
        it.url == this.$route.fullPath &&
        it.code == this.model.Code &&
        it.groupby == this.model.CountdownGroupBy
    );
    console.log(countdown);
    if (countdown?.countdown && moment(countdown.countdown) > moment()) {
      this.model.Countdown = countdown.countdown;
    } else if (this.model.Countdown) {
      this.model.Countdown = undefined;
      this.model.Disabled = false;
      this.model.Label = this.model.SourceLabel;
    }
  }

  handleBeforeClick(command?: any): void {
    if (this.model.Loading != true && this.model.CancelClickEvent != true) {
      this.model.Command = command;
      this.model.Loading = true;
      this.handleSourceClick(this.model, () => {
        this.model.Loading = false;
      });
    }
  }

  @Emit()
  handleSourceClick(model: MiezzButton, complete: () => void): void {
    //
  }

  @Watch("model.Countdown")
  onCountdownChanged(nv: any, ov: any): void {
    this.model.SourceLabel = this.model.Label;
    const countdowns: {
      url: string;
      code: string;
      groupby?: string;
      countdown: Date;
    }[] = JSON.parse(localStorage.getItem("countdowns") ?? "[]");
    let countdown = countdowns.firstOrDefault(
      (it) =>
        it.url == this.$route.fullPath &&
        it.code == this.model.Code &&
        it.groupby == this.model.CountdownGroupBy
    );
    if (!countdown) {
      countdown = {
        url: this.$route.fullPath,
        code: this.model.Code ?? "",
        groupby: this.model.CountdownGroupBy,
        countdown: nv,
      };
      countdowns.push(countdown);
    } else {
      countdown.countdown = nv;
    }
    localStorage.setItem("countdowns", JSON.stringify(countdowns));
    this.countdown();
  }

  countdown(): void {
    if (this.model.Countdown) {
      const s = moment(this.model.Countdown).diff(moment(), "seconds");
      if (s > 0) {
        this.model.Label = `${s}秒`;
        this.model.Disabled = true;
        setTimeout(() => {
          if (moment(this.model.Countdown) < moment()) {
            this.model.Label = this.model.SourceLabel;
            this.model.Disabled = false;
            this.model.Countdown = undefined;
          } else {
            this.countdown();
          }
        }, 1000);
      } else {
        this.model.Label = this.model.SourceLabel;
        this.model.Disabled = false;
        this.model.Countdown = undefined;
      }
    }
  }
}
